module.exports = __webpack_public_path__ + "img/miniapp.b6bd5d32.jpg";